/* tslint:disable */
/* eslint-disable */
export enum OrderDirectionEnum {
  Asc = 'Asc',
  Desc = 'Desc'
}
